import * as Sentry from '@sentry/react';
import React from 'react';
import withTheme from 'src/customizations/themes/hoc/withTheme';
import Column from '../layout/Column';
import Typography from '../typography/Typography';
function resetKeysChanged(prev, next) {
    if (prev === next) {
        return false;
    }
    if (!prev || !next || prev.length !== next.length) {
        return true;
    }
    return prev.some((value, index) => !Object.is(value, next[index]));
}
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, {
            contexts: {
                react: {
                    componentStack: errorInfo.componentStack,
                },
            },
        });
        this.props.onError?.(error, errorInfo);
    }
    componentDidUpdate(prevProps) {
        if (this.state.error &&
            resetKeysChanged(prevProps.resetKeys, this.props.resetKeys)) {
            this.resetError();
        }
    }
    resetError = () => {
        this.setState({ error: null });
    };
    render() {
        if (this.state.error) {
            const theme = this.props.theme;
            return this.props.renderError ? (this.props.renderError(this.state.error, {
                resetError: this.resetError,
            })) : (React.createElement(Column, { ph: theme.spacing.page, pv: theme.spacing.standard.sm, bg: theme.palette.negative.main, style: { borderRadius: theme.borderRadius.standard.md } },
                React.createElement(Typography, { color: theme.palette.negative.contrast }, this.state.error?.message ?? 'Something went wrong')));
        }
        return this.props.children;
    }
}
export default withTheme(ErrorBoundary);
